/* eslint-disable babel/camelcase */
/* eslint-disable react/prefer-stateless-function */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from 'react';

import { ToggleControl } from '@wordpress/components';

import Text from 'Components/Text';
import Label from 'Components/Label';
import FormSelect, { formOptions } from 'Components/FormSelect';

import {
	getCurrentSelected,
	handleTopLevelInput,
	toggleAttribute,
} from 'Utils/helpers';
import TextArea from 'Components/TextArea';

class Leaderboard extends Component {
	render() {
		const { attributes, setAttributes } = this.props;
		const {
			rank,
			heading,
			image,
			avatar,
			name,
			meta,
			score,
			max_score,
			percentage,
			date,
			comment,
			time,
			avatar_size,
			lname,
			ldate,
			lscore,
			lmax_score,
			lpercentage,
			lcomment,
			lrank,
			ltime,
			content,
		} = attributes;
		return (
			<Fragment>
				<FormSelect
					value={getCurrentSelected(formOptions, attributes.formId)}
					onChange={e => {
						setAttributes({ formId: e.value });
					}}
				/>
				<Label title={__('Custom description (optional)', 'ipt_fsqm')}>
					<TextArea
						value={content}
						onChange={e => {
							handleTopLevelInput(e, setAttributes);
						}}
						name="content"
					/>
				</Label>
				<Label title={__('APPEARANCE OPTIONS', 'ipt_fsqm')}>
					<Fragment>
						<ToggleControl
							label={__('Rank', 'ipt_fsqm')}
							help={
								rank
									? __('Show user rank (#<rank>)', 'ipt_fsqm')
									: __('Hide user rank', 'ipt_fsqm')
							}
							checked={rank}
							onChange={() => {
								toggleAttribute(
									'rank',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Heading', 'ipt_fsqm')}
							help={
								heading
									? __(
											'Show form name as heading',
											'ipt_fsqm'
									  )
									: __('Hide heading', 'ipt_fsqm')
							}
							checked={heading}
							onChange={() => {
								toggleAttribute(
									'heading',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Header Image', 'ipt_fsqm')}
							help={
								image
									? __(
											'Show form header image on top',
											'ipt_fsqm'
									  )
									: __('Hide header image', 'ipt_fsqm')
							}
							checked={image}
							onChange={() => {
								toggleAttribute(
									'image',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Avatar', 'ipt_fsqm')}
							help={
								avatar
									? __(
											'Show user avatar (based on email and gravatar)',
											'ipt_fsqm'
									  )
									: __('Hide user avatar', 'ipt_fsqm')
							}
							checked={avatar}
							onChange={() => {
								toggleAttribute(
									'avatar',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('User Name', 'ipt_fsqm')}
							help={
								name
									? __('Show user name', 'ipt_fsqm')
									: __('Hide user name', 'ipt_fsqm')
							}
							checked={name}
							onChange={() => {
								toggleAttribute(
									'name',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('User Meta', 'ipt_fsqm')}
							help={
								meta
									? __(
											'Show total submission and average score',
											'ipt_fsqm'
									  )
									: __('Hide user meta', 'ipt_fsqm')
							}
							checked={meta}
							onChange={() => {
								toggleAttribute(
									'meta',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Score', 'ipt_fsqm')}
							help={
								score
									? __('Show user score', 'ipt_fsqm')
									: __('Hide user score', 'ipt_fsqm')
							}
							checked={score}
							onChange={() => {
								toggleAttribute(
									'score',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Maximum Score', 'ipt_fsqm')}
							help={
								max_score
									? __(
											'Show maximum score (out of)',
											'ipt_fsqm'
									  )
									: __(
											'Hide maximum score (out of)',
											'ipt_fsqm'
									  )
							}
							checked={max_score}
							onChange={() => {
								toggleAttribute(
									'max_score',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Percentage', 'ipt_fsqm')}
							help={
								percentage
									? __('Show score percentage', 'ipt_fsqm')
									: __('Hide score percentage', 'ipt_fsqm')
							}
							checked={percentage}
							onChange={() => {
								toggleAttribute(
									'percentage',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Date', 'ipt_fsqm')}
							help={
								date
									? __('Show submission date', 'ipt_fsqm')
									: __('Hide submission date', 'ipt_fsqm')
							}
							checked={date}
							onChange={() => {
								toggleAttribute(
									'date',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Administrator Comments', 'ipt_fsqm')}
							help={
								comment
									? __(
											'Show administrator remarks',
											'ipt_fsqm'
									  )
									: __(
											'Hide administrator remarks',
											'ipt_fsqm'
									  )
							}
							checked={comment}
							onChange={() => {
								toggleAttribute(
									'comment',
									attributes,
									setAttributes
								);
							}}
						/>
						<ToggleControl
							label={__('Time', 'ipt_fsqm')}
							help={
								time
									? __(
											'Show submission time (if stopwatch enabled)',
											'ipt_fsqm'
									  )
									: __('Hide submission time ', 'ipt_fsqm')
							}
							checked={time}
							onChange={() => {
								toggleAttribute(
									'time',
									attributes,
									setAttributes
								);
							}}
						/>
					</Fragment>
				</Label>
				{avatar ? (
					<Label title={__('Avatar Size (px)', 'ipt_fsqm')}>
						<Text
							value={avatar_size}
							type="number"
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="avatar_size"
						/>
					</Label>
				) : null}
				{name ? (
					<Label title={__('Name Column Label', 'ipt_fsqm')}>
						<Text
							value={lname}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="lname"
						/>
					</Label>
				) : null}
				{date ? (
					<Label title={__('Date Column Label', 'ipt_fsqm')}>
						<Text
							value={ldate}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="ldate"
						/>
					</Label>
				) : null}
				{score ? (
					<Label title={__('Score Column Label', 'ipt_fsqm')}>
						<Text
							value={lscore}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="lscore"
						/>
					</Label>
				) : null}
				{max_score ? (
					<Label title={__('Max Score Column Label', 'ipt_fsqm')}>
						<Text
							value={lmax_score}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="lmax_score"
						/>
					</Label>
				) : null}
				{percentage ? (
					<Label title={__('Percentage Column Label', 'ipt_fsqm')}>
						<Text
							value={lpercentage}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="lpercentage"
						/>
					</Label>
				) : null}
				{comment ? (
					<Label title={__('Comment Column Label', 'ipt_fsqm')}>
						<Text
							value={lcomment}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="lcomment"
						/>
					</Label>
				) : null}
				{rank ? (
					<Label title={__('Rank Title', 'ipt_fsqm')}>
						<Text
							value={lrank}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="lrank"
						/>
					</Label>
				) : null}
				{time ? (
					<Label title={__('Time Column Label', 'ipt_fsqm')}>
						<Text
							value={ltime}
							onChange={e => {
								handleTopLevelInput(e, setAttributes);
							}}
							name="ltime"
						/>
					</Label>
				) : null}
			</Fragment>
		);
	}
}

export default Leaderboard;
